import BaseService from '../../middleware/BaseService';

class VideoTaggingService extends BaseService {
  async postTag(mediaId, params) {
    return await this.post(params, `/medias/${mediaId}/tag`);
  }
}

export default new VideoTaggingService();
